import { render } from "./ListWebinars.vue?vue&type=template&id=c24fc63e&scoped=true"
import script from "./ListWebinars.vue?vue&type=script&lang=js"
export * from "./ListWebinars.vue?vue&type=script&lang=js"

import "./ListWebinars.vue?vue&type=style&index=0&id=c24fc63e&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24fc63e"]])

export default __exports__